<template>
  <span v-html="htmlContent"></span>
</template>

<script>
export default {
  name: 'boolean-value',
  props: {
    value: Boolean
  },
  computed: {
    htmlContent() {
      return this.value ? '<i class="fas fa-check text-success"></i>' : '<i class="fas fa-times text-danger"></i>';
    }
  }
}
</script>
